import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-left-splitview',
    templateUrl: './left-splitview.component.html',
    styleUrls: ['./left-splitview.component.scss'],
    imports: [TranslateModule],
})
export class LeftSplitviewComponent {
    constructor() {}
}
